<template>
  <div>
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品所属分类"
      third-bread="产品所属分类添加"
      first-url="/user/sign"
      second-url="/user/classify"
      title-name="产品所属分类添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="Alist.name" ></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品分类">
          <el-select v-model="Alist.superId" placeholder="请选择">
            <el-tree :data="Large"
                     node-key="id"
                     :props="defaultProps"
            >
              <div class="" slot-scope="{ node, data }" >
                <el-option  :label="data.name" :value="data.id"></el-option>
              </div>
            </el-tree>
          </el-select>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "ProductClassifyAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:null,
        defaultProps:{
          children: 'childClassify',
          label: 'name'
        },
        Alist: {
          'name':null,
          'classifyLogoUrl':null,
          'superId':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetLarge()
    },
    methods:{
      GetUrlList(file){
        this.Alist.classifyLogoUrl=file.data;
      },
      GetLarge(){
        this.$axios.get('/api/productClassify/getTree').then(res=>{

          this.Large=res.data.data;
        })
      },
      handleAdd(){
        if (this.Alist.superId){
          if(this.Alist.classifyLogoUrl || this.Alist.name) {
            this.$axios.post('/api/productClassify/add',this.Alist).then(res=>{
              if(res.data.success == true){
                this.Alist= {
                  'name':null,
                  'classifyLogoUrl':null,
                  'superId':null,
                }//表示Add添加的数据,
                this.$message({
                  message:'添加成功',
                  type:'success'
                })
              }
            })
          } else {
            this.$message.warning('请选择一项进行上传')
          }
        } else {
          this.$message.error('类型必须选择')
        }
      }
    },
  }
</script>

<style scoped>

</style>